(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name AutorController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('AutorController', AutorController);

    AutorController.$inject = ["$rootScope","rutaService","$timeout","debugService","$routeParams","autorService","espaiService","$scope","mapsService","mobileService","$location"];

    function AutorController($rootScope,rutaService,$timeout,debugService,$routeParams,autorService,espaiService,$scope,mapsService,mobileService,$location)
    {
      console.log($routeParams);
    	var vm = this;
    	vm.autor = $routeParams.autor;
      vm.info = {};
      vm.autorInfo = {};
      vm.espaiInfo ={};
      vm.rutas = rutaService;
      vm.mobile = mobileService;
      vm.rutaInfo = {};
      vm.rutaEspaiInfo = [];
      vm.loaded = false;
      vm.printAll = false;

      $scope.mapa = mapsService;

      vm.video = function(media)
      {
        if(media.proveidor == 'Y')
          return "https://www.youtube.com/v/"+media.proveidor_id +"&fs=1&rel=0&color1=0x333333&color2=0x666666&border=0";
        if(media.proveidor == 'V')
          return "https://player.vimeo.com/video/"+ media.proveidor_id;
        if(media.proveidor == '3')
          return "https://www.ccma.cat/video/embed/"+media.proveidor_id;
        if(media.proveidor == 'R')
          return "https://secure-embed.rtve.es/drmn/embed/video/"+media.proveidor_id;

      };

      vm.rutaLiteraria = function()
      {
        if(vm.espaiInfo){
          return rutaService.EspaisIsRuta(vm.espaiInfo.id);
        }
      };

      vm.rutaLiterariaExperiences = function()
      {
        if(vm.espaiInfo){
          return rutaService.ExperienceIsRuta(vm.espaiInfo.id);  
        }
        
      };

  		$scope.$on("onMarkersLoad", function(event, data)
  		{
        console.log("ON MARKERS");
  			//vm.init();
  		});

      vm.concatText = function()
      {
        var length = vm.info.info.text.length;
        if(vm.info.info.context.length>length)
        {
          var length = vm.info.info.context.length;
        }
        vm.info.info.textcontext = [];
        for (var i = 0; i < length; i++) {
          if(vm.info.info.text[i]){
            vm.info.info.text[i].type="text";
            vm.info.info.textcontext.push(vm.info.info.text[i]);
          }

          if(vm.info.info.context[i]){
            vm.info.info.context[i].type="context";
            vm.info.info.textcontext.push(vm.info.info.context[i])
          }
          
        }
        console.log("-------INFOOOOO----")
        console.log(vm.info);
      }

  		vm.init = function()
  		{
        if($routeParams.autor){
  			 vm.autorInfo = autorService.getAutorBySlug(vm.autor);
         
  			 vm.espaiInfo = espaiService.getBiography(vm.autorInfo.id)[0];
  			 
         if(vm.espaiInfo)
         {
            espaiService.getEspaiContent(vm.espaiInfo.id).then(function(data)
            {
              vm.info = data;
              vm.concatText();
              mapsService.centerMap(vm.espaiInfo);
              vm.loaded = true;
            });
            autorService.scrollToAutor(vm.autorInfo.data.slug);
          }else{
            $location.path("/");
          }
        }else if($routeParams.centre)
        {

          if($routeParams.ruta){
            console.log("Tengo el autor");
            vm.autorInfo = autorService.getAutorBySlug($routeParams.ruta);
            console.log(vm.autorInfo);
            vm.espaiInfo = espaiService.getEspaiBySlugAutor($routeParams.centre,vm.autorInfo.id); 
            if(!vm.espaiInfo)
              vm.espaiInfo = espaiService.getEspaiBySlug($routeParams.centre); 

          }else
          {
            //Es un espai
            vm.espaiInfo = espaiService.getEspaiBySlug($routeParams.centre); 
            vm.autorInfo = autorService.getAutorByID(vm.espaiInfo.data.autor);
          }

          console.log(vm.espaiInfo);

          espaiService.getEspaiContent(vm.espaiInfo.id).then(function(data)
            {
               vm.info = data;
               vm.concatText();
               
               
               vm.rutaInfo = vm.rutas.getRutaData(vm.espaiInfo.id);

               console.log(vm.espaiInfo);
               if(vm.espaiInfo.data.ruta){
                  console.log("ES RUTA");
                  var sp = [];
                  var gte = vm.rutas.getEspais(vm.espaiInfo.id);
                  for (var i = 0; i < gte.length; i++) {
                    sp.push(espaiService.getEspaiByID(gte[i].espai_id));
                  }
                  $rootScope.$broadcast('onRutaLoaded');
                  console.log("ES RUTA: for");
                  autorService.openInMenu(vm.espaiInfo.data.autor,"rutas", autorService.getSlugify( vm.rutaInfo.data.nom_ca ) );
                  console.log("ES RUTA: openInMenu");
                  mapsService.centerMapEspais(sp);
                  console.log("ES RUTA: centerMap");
                  autorService.scrollToAutor(vm.autorInfo.data.slug);
                  console.log("Finished Ruta");
                  vm.getInfoEspaisRuta(gte);
                  
                  
                }else
                {
                  
                  if(vm.espaiInfo.data.ambit==4){
                    autorService.openInMenu(vm.espaiInfo.data.autor,"centre");
                    mapsService.centerMap(vm.espaiInfo,true);
                  }
                  else{
                    autorService.openInMenu(vm.espaiInfo.data.autor,"espais");
                    mapsService.centerMap(vm.espaiInfo);
                  }                  
                  
                  autorService.scrollToAutor(vm.autorInfo.data.slug);
                  console.log("centrando el mapa");
                }

                vm.loaded = true;
            });
        }

        if(vm.espaiInfo){
          mapsService.setActiveMarker(vm.espaiInfo.id);
        }

  		};

      //if(autorService.data){
        
        vm.mobile.set('autor',true,'mobile');
        $scope.$watch("mapa.loadedMap",function(newValue,oldValue) {
          console.log(newValue);
          if(newValue)
            $timeout(function()
                {
                    vm.init();
                });
        });
  		  
      //}
      vm.getInfoEspaisRuta = function(espais)
      {
        var espai_id = 0 ;
        for (var i = 0; i < espais.length; i++) {
          espai_id= espais[i].espai_id;
          espaiService.getEspaiContent(espai_id).then(function(data)
            {
              console.log(data);
              var espaiInfo = espaiService.getEspaiByID(data.espai_id);
              vm.rutaEspaiInfo.push({espai_id:data.espai_id,espaiInfo:espaiInfo,info:data});
              console.log(vm.rutaEspaiInfo);
            });     

        }
      }

      vm.print = function()
      {
        vm.printAll = true;
        $timeout(function(){
          vm.printAll = false;
        },2000)
      }

    }
    
})();